import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Country, UserPrivilege } from "../../../../../../shared/constants/Constant";
import { useAppUser } from "../../../../../../contexts/user-context/UserContext";
import { useHistory } from "react-router-dom";
import "./styles.scss";
import ProfilePageTitle from "../../containers/profileHeader";
import FormValidator from "../../../../../../shared/utils/FormValidator";
import { DashboardAccountsPages } from "../../containers/Account";
import { usePermission } from "../../../../../../shared/hooks/usePermission";

interface User {
  uid: string | undefined;
  fullName: string | undefined;
  name?: string;
  email: string | null | undefined;
  userRole: string | undefined;
  country?: Country;
  username: string | undefined;
  dob: Date;
  university: string | undefined;
  contactNo: string | undefined;
  bio: string | undefined;
}

const initUser: User = {
  uid: "",
  fullName: "",
  email: "",
  userRole: "",
  country: Country.SRI_LANKA,
  username: "",
  dob: new Date(),
  university: "",
  contactNo: "",
  bio: "",
};

const UserProfileComponent = () => {
  const appUser = useAppUser();
  const history = useHistory();

  const [user, setUser] = useState(initUser);

  const isTeamMember = usePermission(UserPrivilege.TEAM);

  const getCountryText = (country: Country): string => {
    switch (country) {
      case Country.SRI_LANKA:
        return "Sri Lanka";
      case Country.BOSNIA:
        return "Bosnia and Herzegovina";
      case Country.JAMAICA:
        return "Jamaica";
      case Country.MALAYSIA:
        return "Malaysia";
      case Country.INDIA:
        return "India";
      case Country.INDONESIA:
        return "Indonesia";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("isAuthed") === "true" ||
      sessionStorage.getItem("isAuthed") === "true"
    ) {
      setUser({
        uid: appUser.fireUser?.uid,
        fullName: appUser.displayName,
        email: appUser.fireUser?.email,
        userRole: appUser.userRole.isAdmin
          ? "Admin"
          : appUser.userRole.isModerator
            ? "Moderator"
            : isTeamMember ? "Team Member" : "Member",
        country: appUser.country,
        username: appUser.username,
        dob: appUser.dob,
        university: appUser.university,
        contactNo: appUser.contactNo,
        bio: appUser.bio,
      });
    }
  }, [appUser, isTeamMember]);

  return (
    <>
      <ProfilePageTitle />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
          color: "grey",
        }}
      >
        <Row>
          <Col xs={12} className="text-right mb-3">
            <button
              className="edit-button"
              onClick={() => {
                history.push(DashboardAccountsPages.ACCOUNT_EDIT);
              }}
            >
              Edit
            </button>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={6} lg={6} style={{ paddingRight: "10px" }}>
            <Row>
              <div className="mt-3 p-0" style={{ minWidth: "160px" }}>
                <p>
                  <strong>Full Name</strong>
                </p>
              </div>
              <div
                className="mt-3 d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div className="d-flex align-content-center">
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{ marginLeft: "10px", lineHeight: "27px" }}
                >
                  {user.fullName || user.name}
                </div>
              </div>
            </Row>
            <Row>
              <div className="p-0" style={{ minWidth: "160px" }}>
                <p>
                  <strong>Email</strong>
                </p>
              </div>
              <div
                className=" d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div className="d-flex align-content-center">
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{ marginLeft: "10px", lineHeight: "27px" }}
                >
                  {user.email}
                </div>
              </div>
            </Row>
            {user.dob && !FormValidator.areDatesEqual(user.dob, new Date()) && (
              <Row>
                <div className="p-0" style={{ minWidth: "160px" }}>
                  <p>
                    <strong>Date of Birth</strong>
                  </p>
                </div>
                <div
                  className=" d-flex align-content-center p-0"
                  style={{ flex: 1 }}
                >
                  <div className="d-flex align-content-center">
                    <strong> : </strong>
                  </div>
                  <div
                    className="d-flex align-content-center"
                    style={{ marginLeft: "10px", lineHeight: "27px" }}
                  >
                    {new Date(user.dob).getFullYear() +
                      " " +
                      new Date(user.dob).toLocaleString("default", {
                        month: "long",
                      }) +
                      " " +
                      new Date(user.dob).getDate()}
                  </div>
                </div>
              </Row>
            )}
            {user.university && user.university !== "" && (
              <Row>
                <div className="p-0" style={{ minWidth: "160px" }}>
                  <p>
                    <strong>University / Institute</strong>
                  </p>
                </div>
                <div
                  className=" d-flex align-content-center p-0"
                  style={{ flex: 1 }}
                >
                  <div className="d-flex align-content-center">
                    <strong> : </strong>
                  </div>
                  <div
                    className="d-flex align-content-center"
                    style={{ marginLeft: "10px", lineHeight: "27px" }}
                  >
                    {user.university || ""}
                  </div>
                </div>
              </Row>
            )}
            {user.username && user.username !== "" && (
              <Row>
                <div className="p-0" style={{ minWidth: "160px" }}>
                  <p>
                    <strong>Username</strong>
                  </p>
                </div>
                <div
                  className=" d-flex align-content-center p-0"
                  style={{ flex: 1 }}
                >
                  <div className="d-flex align-content-center">
                    <strong> : </strong>
                  </div>
                  <div
                    className="d-flex align-content-center"
                    style={{ marginLeft: "10px", lineHeight: "27px" }}
                  >
                    {user.username}
                  </div>
                </div>
              </Row>
            )}
            {user.contactNo && user.contactNo !== "" && (
              <Row>
                <div className="p-0" style={{ minWidth: "160px" }}>
                  <p>
                    <strong>Phone No.</strong>
                  </p>
                </div>
                <div
                  className=" d-flex align-content-center p-0"
                  style={{ flex: 1 }}
                >
                  <div className="d-flex align-content-center">
                    <strong> : </strong>
                  </div>
                  <div
                    className="d-flex align-content-center"
                    style={{ marginLeft: "10px", lineHeight: "27px" }}
                  >
                    {user.contactNo || ""}
                  </div>
                </div>
              </Row>
            )}
            {user.userRole !== "Admin" && (
              <Row>
                <div className="p-0" style={{ minWidth: "160px" }}>
                  <p>
                    <strong>Country</strong>
                  </p>
                </div>
                <div
                  className=" d-flex align-content-center p-0"
                  style={{ flex: 1 }}
                >
                  <div className="d-flex align-content-center">
                    <strong> : </strong>
                  </div>
                  <div
                    className="d-flex align-content-center"
                    style={{ marginLeft: "10px", lineHeight: "27px" }}
                  >
                    {getCountryText(user.country || Country.SRI_LANKA)}
                  </div>
                </div>
              </Row>
            )}
            <Row>
              <div className="p-0" style={{ minWidth: "160px" }}>
                <p>
                  <strong>User Role</strong>
                </p>
              </div>
              <div
                className=" d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div className="d-flex align-content-center">
                  <strong> : </strong>
                </div>
                <div
                  className="align-content-center "
                  style={{ marginLeft: "10px", lineHeight: "27px" }}
                >
                  <div className="user-role-message-glow">{user.userRole}</div>
                </div>
              </div>
            </Row>
          </Col>
          {user.bio && user.bio !== "" && (
            <Col xs={12} xl={6} lg={6} className="pt-2 pl-1">
              <Container fluid>
                <Row>
                  <div className="mt-2" style={{ width: "50px" }}>
                    <p>
                      <strong>Bio :</strong>
                    </p>
                  </div>
                  <div className="mt-2" style={{ overflowY: "auto", flex: 1 }}>
                    <p
                      className="small-scroll text-justify"
                      style={{
                        fontSize: "18px",
                        color: "grey",
                        paddingRight: "10px",
                      }}
                    >
                      {user.bio || ""}
                    </p>
                  </div>
                </Row>
              </Container>
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
};

export default UserProfileComponent;
